export const DEFAULT_ROUTES_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 300,
  'col-route-id': 100,
  'col-status': 100,
  'col-agent': 140,
  'col-vehicle': 140,
  'col-time-window': 180,
  'col-duration': 100,
  'col-distance': 100,
  'col-services': 80,
  'col-tasks-count': 80,
  'col-pickup-stops': 80,
  'col-destination-stops': 80,
  'col-pro-number': 120,
  'col-relations': 140,
  'col-reference-ids': 150,
  'col-accounts': 140,
  'col-accounts-external-ids': 150,
  'col-picking-hour': 120,
  'col-trips': 80,
  'col-skills': 120,
  'col-tags': 120,
  'col-plate-number': 120,
  'col-assistant': 140,
  'col-price': 100,
  'col-value': 100,
  'col-load-weight': 80,
  'col-load-volume': 80,
  'col-load-packages': 80,
  'col-load-pallets': 80,
  'col-load-spots': 80,
  'col-load-value': 80,
  'col-capacity-weight': 120,
  'col-capacity-volume': 120,
  'col-capacity-pallets': 120,
  'col-meta-data': 120,
  'col-actions': 20
};

export const DEFAULT_ROUTE_DRILLDOWN_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 260,
  'col-status': 100,
  'col-service-type': 120,
  'col-account': 160,
  'col-contact': 140,
  'col-address': 250,
  'col-time-window': 180,
  'col-eta': 100,
  'col-etd': 100,
  'col-service-time': 100,
  'col-sla': 130,
  'col-packages': 120,
  'col-labels': 120,
  'col-price': 100,
  'col-relations': 140,
  'col-weight': 90,
  'col-volume': 90,
  'col-pallets': 90,
  'col-spots': 90,
  'col-pro-number': 150,
  'col-reference-ids': 150,
  'col-program-type': 140
};

export const DEFAULT_RESOURCES_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 220,
  'col-vehicle': 140,
  'col-logistic-vehicle': 160,
  'col-time-window': 180,
  'col-tags': 120,
  'col-labels': 120,
  'col-routes-count': 100,
  'col-route-names': 180,
  'col-retrips': 100,
  'col-total-duration': 120,
  'col-load-weight': 80,
  'col-load-volume': 80,
  'col-load-packages': 80,
  'col-load-spots': 80,
  'col-load-pallets': 80,
  'col-load-value': 80,
  'col-capacity-weight': 120,
  'col-capacity-volume': 120,
  'col-capacity-pallets': 120
};

export const DEFAULT_SERVICES_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 250,
  'col-account': 160,
  'col-contact': 140,
  'col-pro-number': 150,
  'col-location': 250,
  'col-time-window': 180,
  'col-service-time': 100,
  'col-route': 140,
  'col-resource': 140,
  'col-packages': 120,
  'col-tags': 120,
  'col-skills': 120,
  'col-price': 100,
  'col-relations': 140,
  'col-load-weight': 80,
  'col-load-volume': 80,
  'col-load-packages': 80,
  'col-load-pallets': 80,
  'col-load-spots': 80,
  'col-load-value': 80
};
